<template>
    <div class="widget-template-categories space-y-2">
        <WidgetTemplateCategory
            v-for="(category) in categories"
            :key="category.CategoryID"
            :category="category"
            @select-category="onSelectCategory"
        />
    </div>
</template>

<script setup lang="ts">
import { IWidgetTemplateCategory } from '@/types/templates'
import WidgetTemplateCategory from '@/components/RedesignComponents/Widgets/Create/WidgetTemplateCategory.vue'

defineProps<{
    categories: Array<IWidgetTemplateCategory>
}>()

const emit = defineEmits([ 'select-category' ])

function onSelectCategory (category: IWidgetTemplateCategory) {
    emit('select-category', category)
}
</script>
